import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { AssetImage } from '../../common';
import { TransactionTypes } from '../types/transactions';
import { getTransactionIcon } from '../utils/transactions';
import { FiatSymbolIcon } from '../../trade/Fiat/Reusable/FiatSymbolIcon/FiatSymbolIcon';

interface TransactionItemImageIconProps {
  imageUrl?: string | null;
  transactionType?: TransactionTypes;
  imageAlt?: string | null;
  isFiat?: boolean;
}

const TransactionItemImageIcon: FC<TransactionItemImageIconProps> = ({
  transactionType,
  imageAlt,
  imageUrl,
  isFiat,
}) => {
  return (
    <div
      className={css({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInlineEnd: 'extra_small',
        py: 'extra_small',
        minWidth: 52,
      })}
    >
      {isFiat ? (
        <FiatSymbolIcon />
      ) : (
        <AssetImage
          height={40}
          width={40}
          src={imageUrl as string}
          alt={imageAlt as string}
          placeholder="empty"
        />
      )}
      {transactionType && getTransactionIcon({ transactionType, isFiat })}
    </div>
  );
};

export { TransactionItemImageIcon };
